import React, { Component } from 'react';
import { Route, BrowserRouter, Switch, Redirect, withRouter } from 'react-router-dom';
import LoginForm from './LoginForm'
import { log } from '../../Utilities/Utils'
import { firebaseAuth, logDashboardAction } from '../../config/constants';
import * as UiConsts from '../../config/UiConstants'
import createBrowserHistory from 'history/createBrowserHistory';
import DashBoardContainer from './DashBoardContainer'
import UrgentOrderView from './newDashboard/UrgentComponents/UrgentOrderView'
//import CranesReplacements from './newDashboard/CranesComponents/CranesReplacements'
import ViewArchives from './newDashboard/Archives/ViewArchives'
import ConnectOrder from './newDashboard/ConnectedOrders/ConnectOrder';
// import { ViewCups } from './newDashboard/Cups/ViewCups';
// import { ViewJumpers } from './newDashboard/Jumpers/ViewJumpers';
import { ViewServerResults } from './newDashboard/ViewServerResults/ViewServerResults';
import { ViewServerResultsGet } from './newDashboard/ViewServerResults/ViewServerResultsGet';
import { ViewServerResultsOrderPlacedInDateRange } from './newDashboard/ViewServerResults/ViewServerResultsOrderPlacedInDateRange';
import FabricPayment from './newDashboard/StockPayment/FabricPayment'

import SearchNow from '../newSite/algolia/SearchNow'

import SingleOrderViewDirect from '../newSite/SingleOrderView/SingleOrderViewDirect';

import ViewImage from '../newSite/ViewImage/ViewImage';
import ViewImageNotes from './newDashboard/ImageNotes/ViewImageNotes'

import EnterReceiptsDynamic from './newDashboard/EnterReceipts/EnterReceiptsDynamic';
import DeleteOrders from './newDashboard/DeleteOrders/DeleteOrders';
import EnterAworiLogs from './newDashboard/AworiLog/EnterAworiLogs';
import SingleStatusViewAlgolia from './newDashboard/SingleStatusViewAlgolia/SingleStatusViewAlgolia'
import SingleStatusViewButtonList from './newDashboard/SingleStatusViewAlgolia/SingleStatusViewButtonList'
import StockPayment from './newDashboard/StockPayment/StockPayment';
import DailyExpenses from './newDashboard/Billing/DailyExpenses';
import DailyExpenses_ivan from './newDashboard/Billing/DailyExpenses_ivan';
import ExpensesUpload from './newDashboard/ExpensesUpload/ExpensesUpload'
import ReceiptList from './newDashboard/Receipts/ReceiptList';

import ExpensesDashboard from './newDashboard/Billing/ExpensesDashboard'
import IvanDashboard from './newDashboard/Billing/IvanDashboard'
import TeamLinksDashboard from './newDashboard/Billing/TeamLinksDashboard'


import PrintingChargePayments from './newDashboard/StockPayment/PrintingChargePayments';

import SingleOrderViewArchives from '../newSite/SingleOrderView/SingleOrderViewArchives';
import SingleOrderViewAlgolia from '../newSite/SingleOrderView/SingleOrderViewAlgolia';

import ImageFnder from '../newSite/ImageFinder/ImageFinder';
import ImageSearch from '../newSite/ImageFinder/ImageSearch';
import SearchOrderNumInReceipts from './newDashboard/Billing/SearchOrderNumInReceipts'
import EnterLargeProject from './newDashboard/LargeProjects/EnterLargeProject'
import EnterLargeCustomer from './newDashboard/LargeProjects/EnterLargeCustomer'
import EnterProjectCosts from './newDashboard/LargeProjects/EnterProjectCosts';
import LargeProjectsHome from './newDashboard/LargeProjects/LargeProjectsHome'
import ViewSingleLargeProject from './newDashboard/LargeProjects/ViewSingleLargeProject'
import EditProjectCost from './newDashboard/LargeProjects/EditProjectCost'
import AddDocument from './newDashboard/AddDocuments/AddDocument';
import ViewThisMonthCommission from './newDashboard/LargeProjects/ViewThisMonthCommission';
import ViewDeliveredUnpaid from './newDashboard/LargeProjects/ViewDeliveredUnpaid';
import AddOrderToProject from './newDashboard/LargeProjects/AddOrderToProject';
import ViewCurrentSales from './newDashboard/LargeProjects/ViewCurrentSales'
import ProjectsSearchNow from './newDashboard/LargeProjects/ProjectsSearchNow';
import EnterShirtTypeToDisplay from './newDashboard/ShirtTypes/EnterShirtTypeToDisplay'
import Payroll from './newDashboard/Payroll_Expenses/Payroll';
import MonthlyExpenses from './newDashboard/Payroll_Expenses/MonthlyExpenses';
import ViewLargeProjectDocuments from './newDashboard/LargeProjects/ViewLargeProjectDocuments'

import ReceiptViewSingle from './newDashboard/Receipts/ReceiptViewSingle'

import StockPayment_pythonApi from './newDashboard/StockPayment/StockPayment_pythonApi';
import PaymentsPage from './newDashboard/StockPayment/PaymentsPage';
import CallRecords from './newDashboard/CallRecords/CallRecords';
import WhatsappChatView from './newDashboard/Whatsapp/WhatsappChatView'
import WhatsappMainChatView from './newDashboard/Whatsapp/WhatsappMainChatView';
import WhatsappSingleChatViewNew from './newDashboard/Whatsapp/WhatsappSingleChatViewNew'
import WhatsappSearchNow from './newDashboard/Whatsapp/WhatsappSearchNow';
import WhatsappRejectedChatView from './newDashboard/Whatsapp/WhatsappRejectedChatView';

import { checkAdminEmail } from './newDashboard/algoliaDashboard/AlgoliaMiscUtils';

import EditInHouseProjectCosts from './newDashboard/LargeProjects/EditInHouseProjectCosts'
import AddUraAssess from './newDashboard/ura/AddUraAssess';
import ViewSmsFromPhone from './newDashboard/SmsFromPhone/ViewSmsFromPhone';
import PasswordReset from './newDashboard/PasswordReset/PasswordReset';
import ViewMessageLogs from './newDashboard/Whatsapp/ViewMessageLogs';
import LargeProjectOrderEntry from './newDashboard/LargeProjectOrderEntry/LargeProjectOrderEntry'
import ViewLargeProjectOrderEntry_options from './newDashboard/LargeProjectOrderEntry/ViewLargeProjectOrderEntry_options';
import ViewLargeProjectItem_header from './newDashboard/LargeProjectOrderEntry/ViewLargeProjectItem_header';
import LargeProjectOrderEntry_itemSelection from './newDashboard/LargeProjectOrderEntry/LargeProjectOrderEntry_itemSelection';
import EditLargeProjectItem_option_value from './newDashboard/LargeProjectOrderEntry/EditLargeProjectItem_option_value';
import QueryOrdersAlgolia from '../newSite/algolia/QueryOrdersAlgolia';
import RemoveSalesPersonLeadList from './newDashboard/Sales/RemoveSalesPersonLeadList';
import MobileEnterProjectCosts from './newDashboard/LargeProjects/MobileEnterProjectCosts';
import PhoneMoneyLog from './newDashboard/PhoneMoneyLog/PhoneMoneyLog';
import ViewServerLogs from './newDashboard/ViewLogs/ViewServerLogs';
import SubmitRequisition from './newDashboard/Requisition/SubmitRequisition';
import ViewRequisition from './newDashboard/Requisition/ViewRequisition';
import PaymentAdvance from './newDashboard/PaymentAdvance/PaymentAdvance';
import PayAllowances from './newDashboard/Allowances/PayAllowances';
import EnterUnknowDeposit from './newDashboard/EnterUnknowDeposit/EnterUnknowDeposit';
import PbAccountAccessLog from './newDashboard/PbAccountAccess/PbAccountAccessLog';
import ViewRecentVinylPayments from './newDashboard/StockPayment/ViewVinylPayment';
import UpdateFabricPayment from './newDashboard/StockPayment/UpdateFabricPayment';
import ZapierLogs from './newDashboard/zapier/ZapierLogs';
import UpdateSingleZapierNotif from './newDashboard/zapier/UpdateSingleZapierNotif';
import DeductExpenseAccount from './newDashboard/ExpenseAccounts/DeductExpenseAccount';
import GetRecentUnPaidStockPayments from './newDashboard/StockPayment/GetRecentUnPaidStockPayments';

const history = createBrowserHistory({ forceRefresh: true });

function PrivateRoute({ component: Component, admin, ...rest }) {
    return (
        <Route
            {...rest}
            render={(props) => admin === true
                ? <Component {...props} />
                : <Redirect to={{ pathname: '/login', state: { from: props.location } }} />}
        />
    )
}


function LoginRoute({ component: Component, admin, loginMethod, ...rest }) {
    return (
        <Route
            {...rest}
            render={(props) => admin === true
                ? <Redirect to={{ pathname: '/dashboard', state: { from: props.location } }} />
                : <LoginForm loginMethod={loginMethod} />}
        />
    )
}

export default class MainDashboard extends Component {
    constructor(props) {
        super(props);

        this.state = ({
            authed: false,
            loading: true,
            // loading: false,
            user: '',
            // userFromNode: '',
            // userFromFirebaseUserNode: '',
            admin: false,
            algoliaUser: ''
        })

        this.loginUser = this.loginUser.bind(this);
    }


    componentDidMount() {
        this.removeListener = firebaseAuth().onAuthStateChanged((user) => {
            if (user) {
                // log("mdbrx1 user exists..");
                // let isAnonymous = user.isAnonymous;
                let uid = user.uid;
                // log("mdbrx12 uid:" + uid)



                if (user.email) {
                    // log("mdbrx13 user.email:" + user.email)

                    checkAdminEmail(user.email, this.setAdminResult)

                    this.setState({
                        //authed: true,
                        //admin: true,
                        // loading: false,
                        user: user,

                        //uid: user.uid,
                        //loading: false
                    })
                } else {
                    this.setState({
                        authed: false,
                        admin: false,
                        // loading: false,
                        user: user,
                        uid: user.uid,
                        loading: false
                    })
                }


            } else {
                log("px13 user DOES NOT exist..");
                this.setState({
                    authed: false,
                    loading: false
                })
            }
        })
    }


    setAdminResult = (returnObject) => {
        // console.log("++++++ mdbrx14 setAdminResult");
        // console.log("mdbrx15 returnObject:" + JSON.stringify(returnObject, null, 3));

        if (returnObject.algoliaUser && returnObject.algoliaUser.isAdmin) {
            //console.log("mdbrx16 returnObject.algoliaUser && returnObject.algoliaUser.isAdmin:"); 

            this.setState({
                authed: true,
                admin: true,
                algoliaUser: returnObject.algoliaUser,
                loading: false
            })

            //logDashboardAction(logAction, adminEmail, order_num){
            //logDashboardAction(returnObject.algoliaUser.key+" logged in", returnObject.algoliaUser.key,null);
        } else {
            this.setState({
                authed: false,
                admin: false,
                algoliaUser: '',
                loading: false
            })
            alert("Error occured...");
        }

    }

    loginUser(email, password) {
        log("px19 ++++++++:loginUser");
        log("px20 email:" + email);

        this.setState({ loading: true });

        firebaseAuth().signInWithEmailAndPassword(email, password)
            //.then(tempFunc(user.uid))
            .then((user) => {
                console.log('logged in:', user.email);

                logDashboardAction(user.email + " login", user.email, null, "login");

                this.setState({
                    authed: true,
                    admin: true,
                    // loading: false,
                    user: user,
                    uid: user.uid,
                    loading: false
                })
            })
            .catch((error) => {
                // Handle Errors here.
                var errorCode = error.code;
                var errorMessage = error.message;
                if (errorCode === 'auth/wrong-password') {
                    alert('Wrong password.');
                } else {
                    alert(errorMessage);
                }
                console.log(error);

                logDashboardAction(email + " FAILED LOGIN ", email, null, "login");

                this.setState({ loading: false });
            });
    }



    render() {

        const routerUI = this.state.algoliaUser && this.state.algoliaUser != '' && this.state.algoliaUser.isAdmin
            ? <BrowserRouter>
                <Switch>
                    <PrivateRoute admin={this.state.admin} user={this.state.user}
                        exact path='/dashboard' component={DashBoardContainer} />


                    {/* <Route exact path='/dashboard' component={love} /> */}
                    {/* <Route path='/dashboard/login' component={LoginForm} /> */}
                    {/* <Route path='/dashboard/login' render={() => <LoginForm loginMethod={this.loginUser} />} /> */}


                    <LoginRoute admin={this.state.admin} loginMethod={this.loginUser}
                        path='/login' component={LoginForm} />
                    {/* <LoginRoute admin={this.state.admin} path='/dashboard/login' render={() => <LoginForm loginMethod={this.loginUser} />} /> */}

                    {/* URGENT */}
                    {/* <PrivateRoute admin={this.state.admin} exact path='/dashboard/urgent'
                        component={UrgentOrderView} /> */}

                    {/* ARCHIVES */}
                    <PrivateRoute admin={this.state.admin} exact path='/dashboard/viewArchives'
                        component={ViewArchives} />

                    {/* SHOW CONNECTED ORDERS */}
                    <PrivateRoute admin={this.state.admin} exact path='/dashboard/connectedOrders/:phoneNumber'
                        component={ConnectOrder} />

                    {/* SHOW SERVER RESULTS ORDERS */}
                    <PrivateRoute admin={this.state.admin} exact path='/dashboard/viewServerResults/:serverurl'
                        component={ViewServerResults} />

                    {/* SHOW SERVER RESULTS ORDERS */}
                    <PrivateRoute admin={this.state.admin} exact path='/dashboard/viewServerResultsGet/:serverurl'
                        component={ViewServerResultsGet} />

                    <PrivateRoute admin={this.state.admin} exact path='/dashboard/ordersInDateRange/:dateRangeString'
                        component={ViewServerResultsOrderPlacedInDateRange} />

                    <PrivateRoute admin={this.state.admin} exact path='/dashboard/ordersByOrderType/:dateRangeString'
                        component={ViewServerResultsOrderPlacedInDateRange} />


                    {/* FIND ORDERS WITH NO GENDER IN A DATE RANGE */}
                    <PrivateRoute admin={this.state.admin} exact path='/dashboard/findOrdersInDateRangeNoGender/:flag/:dateRangeString'
                        component={ViewServerResultsOrderPlacedInDateRange} />

                    {/* searchNow */}
                    <PrivateRoute admin={this.state.admin} exact path='/dashboard/searchNow'
                        component={SearchNow} />

                    <PrivateRoute admin={this.state.admin} exact path='/dashboard/searchNow/:ivan'
                        component={SearchNow} />


                    {/* SINGLE ORDER VIEW */}
                    <PrivateRoute admin={this.state.admin} exact path='/dashboard/singleOrderView/:order_num'
                        component={SingleOrderViewDirect} />


                    <PrivateRoute admin={this.state.admin} exact path='/dashboard/singleOrderViewArchives'
                        component={SingleOrderViewArchives} />

                    <PrivateRoute admin={this.state.admin} exact path='/dashboard/singleOrderViewAlgolia/:order_num'
                        component={SingleOrderViewAlgolia} />

                    {/* VIEW ORDER */}
                    {/* <PrivateRoute admin={this.state.admin} exact path='/dashboard/viewOrder'
                    component={SingleOrderView} /> */}


                    {/* VIEW image */}
                    {/* <PrivateRoute admin={this.state.admin} exact path='/dashboard/ViewImage'
                        component={ViewImage} /> */}

                    {/* enter receipt */}
                    <PrivateRoute admin={this.state.admin} exact path='/dashboard/enterReciept'
                        component={EnterReceiptsDynamic} />

                    {/* <PrivateRoute admin={this.state.admin} exact path='/dashboard/imageNotes/:orderKey'
                        component={ViewImageNotes} /> */}

                    {/* <PrivateRoute admin={this.state.admin} exact path='/dashboard/deleteOrders'
                        component={DeleteOrders} /> */}

                    <PrivateRoute admin={this.state.admin} exact path='/dashboard/enterAworiLog'
                        component={EnterAworiLogs} />

                    {/* <PrivateRoute admin={this.state.admin} exact path='/dashboard/singleStatusView/:status'
                        component={SingleStatusViewAlgolia} /> */}

                    {/* <PrivateRoute admin={this.state.admin} exact path='/dashboard/singleStatusViewButtons'
                        component={SingleStatusViewButtonList} /> */}

                    {/* <PrivateRoute admin={this.state.admin} exact path='/dashboard/stockPayment'
                    component={StockPayment} /> */}

                    {/* <PrivateRoute admin={this.state.admin} exact path='/dashboard/stockPayment'
                        component={StockPayment_pythonApi} /> */}


                    <PrivateRoute admin={this.state.admin} exact path='/dashboard/paymentsPage'
                        component={PaymentsPage} />

                    <PrivateRoute admin={this.state.admin} exact path='/dashboard/dailyExpenses'
                        component={DailyExpenses} />

                    <PrivateRoute admin={this.state.admin} exact path='/dashboard/expensesUpload'
                        component={ExpensesUpload} />

                    <PrivateRoute admin={this.state.admin} exact path='/dashboard/receipList'
                        component={ReceiptList} />

                    <PrivateRoute admin={this.state.admin} exact path='/dashboard/expensesDashboard'
                        component={ExpensesDashboard} />


                    {/* <PrivateRoute admin={this.state.admin} exact path='/dashboard/payPrintingCharges'
                        component={PrintingChargePayments} /> */}

                    <PrivateRoute admin={this.state.admin} exact path='/dashboard/imageUpload'
                        component={ImageFnder} />

                    <PrivateRoute admin={this.state.admin} exact path='/dashboard/imageSearch'
                        component={ImageSearch} />

                    {/* <PrivateRoute admin={this.state.admin} exact path='/dashboard/searchReceiptNumber'
                        component={SearchOrderNumInReceipts} /> */}

                    <PrivateRoute admin={this.state.admin} exact path='/dashboard/enterLargeCustomer'
                        component={EnterLargeCustomer} />

                    <PrivateRoute admin={this.state.admin} exact path='/dashboard/enterLargeProject'
                        component={EnterLargeProject} />

                    <PrivateRoute admin={this.state.admin} exact path='/dashboard/enterProjectCosts'
                        component={EnterProjectCosts} />

                    {/* -----  FIXED ----- */}
                    <PrivateRoute admin={this.state.admin} exact path='/dashboard/largeProjectsHome'
                        component={LargeProjectsHome} />

                    {/* -----  FIXED ----- */}
                    <PrivateRoute admin={this.state.admin} exact path='/dashboard/largeProjectsHome/:filter'
                        component={LargeProjectsHome} />

                    {/* -----  FIXED ----- */}
                    <PrivateRoute admin={this.state.admin} exact path='/dashboard/viewLargeProject/:projectId'
                        component={ViewSingleLargeProject} />

                    {/* -----  FIXED ----- */}
                    <PrivateRoute admin={this.state.admin} exact path='/dashboard/editProjectCost/:projectId/:costId/:platform'
                        component={EditProjectCost} />

                    {/* -----  FIXED ----- */}
                    <PrivateRoute admin={this.state.admin} exact path='/dashboard/addDocument'
                        component={AddDocument} />

                    {/* <PrivateRoute admin={this.state.admin} exact path='/dashboard/ViewThisMonthCommission'
                        component={ViewThisMonthCommission} /> */}

                    {/* <PrivateRoute admin={this.state.admin} exact path='/dashboard/ViewDeliveredUnpaid'
                        component={ViewDeliveredUnpaid} /> */}

                    {/* -----  FIXED ----- */}
                    <PrivateRoute admin={this.state.admin} exact path='/dashboard/AddOrderToProject/:fbOrderKey'
                        component={AddOrderToProject} />

                    {/* -----  FIXED ----- */}
                    <PrivateRoute admin={this.state.admin} exact path='/dashboard/ViewCurrentSales'
                        component={ViewCurrentSales} />

                    {/* -----  FIXED ----- */}
                    <PrivateRoute admin={this.state.admin} exact path='/dashboard/ProjectsSearchNow'
                        component={ProjectsSearchNow} />

                    {/* -----  FIXED ----- */}
                    <PrivateRoute admin={this.state.admin} exact path='/dashboard/ProjectsSearchNow/:platform'
                        component={ProjectsSearchNow} />

                    {/* -----  FIXED ----- */}
                    <PrivateRoute admin={this.state.admin} exact path='/dashboard/enterShirtTypeToDisplay'
                        component={EnterShirtTypeToDisplay} />

                    {/* -----  FIXED ----- */}
                    <PrivateRoute admin={this.state.admin} exact path='/dashboard/payroll'
                        component={Payroll} />

                    {/* -----  FIXED ----- */}
                    <PrivateRoute admin={this.state.admin} exact path='/dashboard/monthlyExpenses'
                        component={MonthlyExpenses} />

                    {/* -----  FIXED ----- */}
                    <PrivateRoute admin={this.state.admin} exact path='/dashboard/dailyExpenses_ivan'
                        component={DailyExpenses_ivan} />

                    {/* <PrivateRoute admin={this.state.admin} exact path='/dashboard/viewLargeProjectDocuments'
                        component={ViewLargeProjectDocuments} /> */}

                    {/* -----  FIXED ----- */}
                    <PrivateRoute admin={this.state.admin} exact path='/dashboard/viewReceipt/:recNum'
                        component={ReceiptViewSingle} />

                    {/* -----  FIXED ----- */}
                    <PrivateRoute admin={this.state.admin} exact path='/dashboard/ivan'
                        component={IvanDashboard} />

                    {/* -----  FIXED ----- */}
                    <PrivateRoute admin={this.state.admin} exact path='/dashboard/paymentsPage'
                        component={PaymentsPage} />

                    <PrivateRoute admin={this.state.admin} exact path='/dashboard/callRecords'
                        component={CallRecords} />

                    {/* <PrivateRoute admin={this.state.admin} exact path='/dashboard/chatView'
                    component={WhatsappChatView} /> */}

                    {/* -----  FIXED ----- */}
                    <PrivateRoute admin={this.state.admin} exact path='/dashboard/chatView'
                        component={WhatsappMainChatView} />

                    {/* -----  FIXED ----- */}
                    <PrivateRoute admin={this.state.admin} exact path='/dashboard/singleChat/:number'
                        component={WhatsappSingleChatViewNew} />

                    {/* -----  FIXED ----- */}
                    <PrivateRoute admin={this.state.admin} exact path='/dashboard/WhatsappSearchNow'
                        component={WhatsappSearchNow} />

                    {/* -----  FIXED ----- */}
                    <PrivateRoute admin={this.state.admin} exact path='/dashboard/WhatsappRejectedChatView'
                        component={WhatsappRejectedChatView} />

                    {/* -----  FIXED ----- */}
                    <PrivateRoute admin={this.state.admin} exact path='/dashboard/editInHouseProjectCost/:inHouseCostId'
                        component={EditInHouseProjectCosts} />

                    {/* -----  FIXED ----- */}
                    <PrivateRoute admin={this.state.admin} exact path='/dashboard/addUraAssess'
                        component={AddUraAssess} />

                    {/* -----  FIXED ----- */}
                    <PrivateRoute admin={this.state.admin} exact path='/dashboard/viewSmsFromPhone'
                        component={ViewSmsFromPhone} />

                    {/* -----  FIXED ----- */}
                    <PrivateRoute admin={this.state.admin} exact path='/dashboard/passwordReset'
                        component={PasswordReset} />

                    {/* -----  FIXED ----- */}
                    <PrivateRoute admin={this.state.admin} exact path='/dashboard/viewMessageLogs/:server/:messageId'
                        component={ViewMessageLogs} />

                    {/* -----  FIXED ----- */}
                    <PrivateRoute admin={this.state.admin} exact path='/dashboard/largeProjectItemSelection/:projectId'
                        component={LargeProjectOrderEntry_itemSelection} />

                    {/* -----  FIXED ----- */}
                    <PrivateRoute admin={this.state.admin} exact path='/dashboard/largeProjectEnterItem/:projectId/:item'
                        component={LargeProjectOrderEntry} />

                    {/* -----  FIXED ----- */}
                    <PrivateRoute admin={this.state.admin} exact path='/dashboard/viewLargeProjectItems/:projectId'
                        component={ViewLargeProjectItem_header} />

                    {/* -----  FIXED ----- */}
                    <PrivateRoute admin={this.state.admin} exact path='/dashboard/editLargeProjectItem_option_value/:projectId/:largeProjectItem_option_id'
                        component={EditLargeProjectItem_option_value} />


                    <PrivateRoute admin={this.state.admin} exact path='/dashboard/queryOrdersAlgolia'
                        component={QueryOrdersAlgolia} />

                    <PrivateRoute admin={this.state.admin} exact path='/dashboard/removeSalesPersonLeadList'
                        component={RemoveSalesPersonLeadList} />

                    <PrivateRoute admin={this.state.admin} exact path='/dashboard/mobileEnterProjectCosts/:projectId'
                        component={MobileEnterProjectCosts} />

                    <PrivateRoute admin={this.state.admin} exact path='/dashboard/phoneMoneyLog'
                        component={PhoneMoneyLog} />

                    {/* -----  FIXED ----- */}
                    <PrivateRoute admin={this.state.admin} exact path='/dashboard/teamLinks'
                        component={TeamLinksDashboard} />

                    {/* -----  FIXED ----- */}
                    <PrivateRoute admin={this.state.admin} exact path='/dashboard/viewServerLogs/:methodName/:server'
                        component={ViewServerLogs} />

                    <PrivateRoute admin={this.state.admin} exact path='/dashboard/submitRequisition'
                        component={SubmitRequisition} />

                    <PrivateRoute admin={this.state.admin} exact path='/dashboard/submitRequisition/:idbidding'
                        component={SubmitRequisition} />

                    <PrivateRoute admin={this.state.admin} exact path='/dashboard/viewRequisition/:reqId'
                        component={ViewRequisition} />

                    <PrivateRoute admin={this.state.admin} exact path='/dashboard/paymentAdvance'
                        component={PaymentAdvance} />

                    <PrivateRoute admin={this.state.admin} exact path='/dashboard/payAllowances'
                        component={PayAllowances} />

                    <PrivateRoute admin={this.state.admin} exact path='/dashboard/enterUnknowDeposit'
                        component={EnterUnknowDeposit} />

                    <PrivateRoute admin={this.state.admin} exact path='/dashboard/enterFabricPayment'
                        component={FabricPayment} />

                    <PrivateRoute admin={this.state.admin} exact path='/dashboard/pbAccountAccessLog'
                        component={PbAccountAccessLog} />

                    <PrivateRoute admin={this.state.admin} exact path='/dashboard/viewRecentVinylPayments'
                        component={ViewRecentVinylPayments} />

                    <PrivateRoute admin={this.state.admin} exact path='/dashboard/updateFabricPayment/:idfabricPayments'
                        component={UpdateFabricPayment} />

                    <PrivateRoute admin={this.state.admin} exact path='/dashboard/getZapierNotifs'
                        component={ZapierLogs} />

                    <PrivateRoute admin={this.state.admin} exact path='/dashboard/updateSingleZapierNotif/:idzapierNotifs'
                        component={UpdateSingleZapierNotif} />

                    <PrivateRoute admin={this.state.admin} exact path='/dashboard/updateSingleZapierNotif/:idzapierNotifs/:putBack'
                        component={UpdateSingleZapierNotif} />

                    <PrivateRoute admin={this.state.admin} exact path='/dashboard/updateSingleZapierNotif'
                        component={UpdateSingleZapierNotif} />

                    <PrivateRoute admin={this.state.admin} exact path='/dashboard/deductExpenseAccount'
                        component={DeductExpenseAccount} />

                    <PrivateRoute admin={this.state.admin} exact path='/dashboard/getRecentUnPaidStockPayments'
                        component={GetRecentUnPaidStockPayments} />


                </Switch>
            </BrowserRouter>
            : <h3>Error...Something went wrong</h3>

        return (this.state.loading === true ? <UiConsts.LoadingComponent /> :
            <div>
                {routerUI}
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/components/dashBoard/MainDashboard.js